import React, { useState } from 'react';
import { PricesEntity, TablePrices } from '@partsbadger/library';
import { Button, Modal } from 'antd';
import QuoteStore from '../../stores/QuoteStore';
import Text from 'antd/lib/typography/Text';

interface Props {
    quote_id: number;
    item_id: number;
    handleClosePrices: () => void;
    handleSelect?: (qty: number) => void;
    editable?: boolean;
    requestNewQuote?: () => void;
}

const AllDynamicQuantities = (props: Props) => {
    const [isLoadingPricesList, setIsLoadingPricesList] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pricesList, setPricesList] = useState<{
        pageSize: number;
        count: number;
        current: number;
        results: PricesEntity[];
    }>();

    React.useEffect(() => {
        getPricesList(page);
    }, []);

    const getPricesList = (_page = 1) => {
        setIsLoadingPricesList(true);
        QuoteStore.getDynamicPricesList(props.quote_id, props.item_id, _page)
            .then(response => {
                setPricesList(response);
            })
            .finally(() => setIsLoadingPricesList(false));
    };

    return (
        <>
            <Modal
                title={'Price per Quantity'}
                centered
                open
                onCancel={() => props.handleClosePrices()}
                footer={
                    props.editable && (
                        <Button
                            key={'1'}
                            type="link"
                            onClick={() => {
                                if (props.requestNewQuote) {
                                    props.requestNewQuote();
                                }
                            }}
                        >
                            <Text type="secondary">Did not see your desired quantity,</Text>
                            &nbsp;request a new quote here?
                        </Button>
                    )
                }
            >
                <TablePrices
                    loading={isLoadingPricesList}
                    prices={pricesList?.results ?? []}
                    count={pricesList?.count ?? 30}
                    current={pricesList?.current ?? 1}
                    pageSize={pricesList?.pageSize ?? 1}
                    handlePageChange={page => {
                        getPricesList(page);
                        setPage(page);
                    }}
                    handleSelect={async qty => props.handleSelect && props.handleSelect(qty)}
                />
            </Modal>
        </>
    );
};

export default AllDynamicQuantities;
